import { SCREENS } from '~/constants/screens';
import { USER_ROLES } from '~/constants/user';
import ScreenHeader from '~/view/containers/Headers/containers/ScreenHeader/ScreenHeader';
import { IScreenTab } from '~/view/containers/ScreenTabsNavigation/ScreenTabsNavigation';

const navigationOptions = [
  { path: SCREENS.BRANCHES(), title: 'branches', accessRoles: [USER_ROLES.RESTAURANT_MANAGER] },
  { path: SCREENS.BRANCHES_WORKING_HOURS(), title: 'branch_working_hours_tab' },
];

type Props = {
  children: (props: { navigation: IScreenTab[] }) => React.ReactNode;
};

const BranchesManagementHeader = ({ children }: Props) => (
  <div>
    <ScreenHeader title="branches_section_header" options={[]} isBeta />
    {children({ navigation: navigationOptions })}
  </div>
);

export default BranchesManagementHeader;
